import React from 'react';

const BookingConditions = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '1000px', margin: 'auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>

            <div style={{ marginTop: '28px' }}>
                <p>1. Select your favourite villa or apartment. Browse through our site using the search engine or email us and we will send you a list of suitable holiday properties.</p>
                <p>2. Check availability using the calendar to confirm the villa is available.</p>
                <p>3. Click enquire and send us your details or enter your details via the book online option.</p>
                <p>4. We will confirm your booking via telephone or email and send you a written confirmation with all the details.</p>
                <p>5. A 30% deposit is required to hold your booking (if the booking is made more then 10 weeks before your travel date). The full amount is due if you are travelling within 10 weeks.</p>
                <p>6. We will contact you when the balance is due and send you full details of your holiday.</p>
            </div>

            <h2>Booking Conditions</h2>

            <h3 style={{ fontSize:'15px' }}>Confirmation of booking</h3>
            <p>
                Once the contract is made we are responsible to provide the accommodation as described on our confirmation and you are responsible as the client to pay for it, in each case as subject to these terms and conditions. You must be at least 24 years of age.
            </p>

            <h3 style={{ fontSize:'15px' }}>Deposit</h3>
            <p>
                A 30% deposit must accompany all bookings made. If you book within ten weeks of arrival, you must remit the total cost of your accommodation and any specified extras. If we do not receive your deposit within 2 days of your receipt of the booking form we reserve the right to assume you no longer wish to proceed with the booking, and offer these dates as available to other customers.
            </p>

            <h3 style={{ fontSize:'15px' }}>Balance</h3>
            <p>
                After payment of initial deposit any balance due must be paid no later than 10 weeks before your arrival date. If you fail to pay the balance by this time, we reserve the right to cancel the booking and make cancellation charges at the rates below, which will be notified to you in writing.
            </p>

            <h3 style={{ fontSize:'15px' }}>Changes requested by the client</h3>
            <p>
                If, after we confirm the booking, you wish to alter the reservation in any way we will try to make the change requested. You must notify us in writing as soon as possible. If any of the occupants exceed the number of persons agreed in the accommodation details form, any breach of this condition gives us the right to terminate the booking immediately.
            </p>

            <h3 style={{ fontSize:'15px' }}>Cancellation</h3>
            <p>
                If you decide to cancel the holiday, then this right must be exercised by the person whose name is on the booking form. Notice of cancellation must be given in writing. The time of cancellation shall be taken as the date written notice is received.
            </p>
            <ul>
                <li>Over 8 weeks prior - loss of your holiday cost deposit or initial reservation.</li>
                <li>For 7 - 8 weeks prior - 50% of your holiday cost</li>
                <li>For 2 - 7 weeks prior - 75% of your holiday cost</li>
                <li>For 1 - 2 weeks prior - 90% of your holiday cost</li>
                <li>Less than 1 week - 100% of your holiday cost</li>
            </ul>

            <h3 style={{ fontSize:'15px' }}>Complaints</h3>
            <p>
                We will do our best to provide you with accommodation for a successful and enjoyable holiday but even the best-laid plans can go wrong. If you have a complaint or a problem with your accommodation during your stay you must inform us immediately.
            </p>

            <h3 style={{ fontSize:'15px' }}>Breakages and damages</h3>
            <p>
                All bookings are accepted on the strict understanding that accidental breakages, loss, damages, key replacements and additional housekeeping charges in the form of a credit imprint upon arrival. We always inform our clients when we have received from caretakers or management complaints. Any costs have been notified to proceed with any payment.
            </p>

            <h3 style={{ fontSize:'15px' }}>Accommodation</h3>
            <p>
                The number of "Nights" stated on every price panel refers to the number of nights accommodation reserved in your villa. You are advised to arrive at your accommodation no earlier than the time that management has made final cleaning before 4:00pm, the departure time is on your departure on the villa during changeover days. Departure time is 10.00am unless other arrangements are made in writing and written confirmation is received.
            </p>

            <h3 style={{ fontSize:'15px' }}>Arrival and returning confirmation</h3>
            <p>
                Once your booking has been confirmed and arrangements it is your responsibility to ensure that you arrive on the correct day and time as specified and you inform your local agent.
            </p>

            <h3 style={{ fontSize:'15px' }}>Special Requests</h3>
            <p>
                We are happy to assist you in your special requests but they must be clearly noted on the booking form or in writing to us after the booking has been made. Where charges are applicable, they will be added to your holiday balance. Extra beds are not provided in any accommodation unless stated and agreed at the time of reservation. If special requests have been made your final balance has been prepared and includes these charges and charges (if any) from your group leader.
            </p>

            <h3 style={{ fontSize:'15px' }}>Satellite/Cable T.V.</h3>
            <p>
                Where properties are noted to satellite or cable TV, please note that the channels available are subject to the owner's subscription plan with the satellite / cable operator.
            </p>

            <h3 style={{ fontSize:'15px' }}>Holiday insurance</h3>
            <p>
                Holiday insurance is the sole responsibility of each individual party member. Sunboundvillas.com accepts no liability for loss, damage, personal injury or the cost of medical or other treatment.
            </p>

            <h3 style={{ fontSize:'15px' }}>Swimming Pool</h3>
            <p>
                Children must not use the swimming pool without adult supervision.
            </p>
        </div>
    );
};

export default BookingConditions;
